import { linkLogin, linkSignUp } from 'design-studio/lib'

/**
 * Site URL + label map. Sign-in hrefs come from imandra navigation data via
 * `design-studio/lib` (sub/design-studio).
 */
export const NavigationData = {
  home: { name: 'Home', href: '/', 'aria-label': 'Navigate to Home' },
  install: {
    name: 'Install',
    href: '/docs/getting-started/installation/',
    'aria-label': 'Navigate to Install',
  },
  docs: {
    name: 'Docs',
    href: '/docs/',
    'aria-label': 'Navigate to Docs',
  },
  contact: {
    name: 'Contact',
    href: 'https://www.imandra.ai/contact',
    'aria-label': 'Contact us',
  },
  login: {
    name: 'Login',
    href: linkLogin,
    'aria-label': 'Login to Imandra Universe',
  },
  signup: {
    name: 'Sign up',
    href: linkSignUp,
    'aria-label': 'Sign up for Imandra Universe',
    /** Hero CTA — visible label; aria must include this prefix (Lighthouse). */
    heroLabel: 'Start now',
    heroAriaLabel: 'Start now — sign up for Imandra Universe',
  },
} as const

export { DataFooterLinks } from 'design-studio'
